export default defineNuxtRouteMiddleware((to) => {
  // Ensure the path is exactly /index.html
  if (to.path === "/index.html" && to.query.url) {
    return navigateTo(`/`, { redirectCode: 301 });
  }
  return;
});
